"use strict";
exports.__esModule = true;
exports.QuoteIsLoading$ = exports.QuoteLoaded$ = exports.QuoteQuery = void 0;
var akita_1 = require("@datorama/akita");
var quote_store_1 = require("./quote.store");
var operators_1 = require("rxjs/operators");
exports.QuoteQuery = akita_1.createQuery(quote_store_1.QuoteStore);
exports.QuoteLoaded$ = exports.QuoteQuery.select()
    .pipe(operators_1.filter(function (quote) { return quote.rooms && quote.rooms.length && !quote.loading; }));
exports.QuoteIsLoading$ = exports.QuoteQuery.selectLoading();
//# sourceMappingURL=quote.query.js.map